import { COLOR_SYSTEM } from "components/design/design-system";
import { typography } from "components/design/typography";
import styled from "styled-components";

interface InputStyledProps {
  error?: boolean;
  backgroundColor?: string;
  disabledColor?: boolean;
}

export const InputField = styled.input<InputStyledProps>`
  display: block;
  min-width: 30px;
  height: 100%;
  appearance: none;
  outline: none;
  border: none;
  border-radius: inherit;
  flex: 1;
  background-color: transparent;
  color: ${COLOR_SYSTEM.get("Gray")?.[800]};
  ${typography.get("Body1")};

  &::placeholder {
    color: ${COLOR_SYSTEM.get("Gray")?.[300]};
  }
  &:disabled {
    opacity: ${({ disabledColor }) => (disabledColor ? "0.3" : "1")};
  }

  /* number input의 화살표 버튼 숨기기 */
  &[type="number"]::-webkit-inner-spin-button,
  &[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &[type="number"] {
    -moz-appearance: textfield;
  }
`;

export const TextAreaField = styled.textarea<InputStyledProps>`
  padding: 11.5px 16px;
  display: block;
  min-width: 70px;
  width: 100%;
  min-height: 180px;
  height: 100%;
  appearance: none;
  outline: none;
  border: none;
  flex: 1;
  background-color: ${({ error, backgroundColor }) =>
    backgroundColor ?? COLOR_SYSTEM.get(error ? "Red" : "Gray")?.[10]};
  color: ${COLOR_SYSTEM.get("Gray")?.[800]};
  resize: none;
  border: ${({ error }) =>
    error ? `1px solid ${COLOR_SYSTEM.get("Red")?.[50]}` : "1px solid transparent"};
  border-radius: 12px;
  box-sizing: border-box;
  ${typography.get("Body1")};

  &::placeholder {
    color: ${COLOR_SYSTEM.get("Gray")?.[300]};
  }

  &:focus {
    background-color: ${({ error, backgroundColor }) =>
      backgroundColor ?? (error ? COLOR_SYSTEM.get("Red")?.[10] : COLOR_SYSTEM.get("Gray")?.[20])};
    border: ${({ error }) =>
      error
        ? `1px solid ${COLOR_SYSTEM.get("Red")?.[50]}`
        : `1px solid ${COLOR_SYSTEM.get("Gray")?.[100]}`};
  }
`;

export const InputWrapper = styled.div<InputStyledProps>`
  height: 48px;
  padding: 11.5px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ error, backgroundColor }) =>
    backgroundColor ?? COLOR_SYSTEM.get(error ? "Red" : "Gray")?.[10]};
  box-sizing: border-box;
  border-radius: 12px;
  border: ${({ error }) =>
    error ? `1px solid ${COLOR_SYSTEM.get("Red")?.[50]}` : "1px solid transparent"};

  &:focus-within {
    border: ${({ error }) =>
      error
        ? `1px solid ${COLOR_SYSTEM.get("Red")?.[50]}`
        : `1px solid ${COLOR_SYSTEM.get("Gray")?.[100]}`};
    background-color: ${({ error, backgroundColor }) =>
      backgroundColor ?? (error ? COLOR_SYSTEM.get("Red")?.[10] : COLOR_SYSTEM.get("Gray")?.[20])};
  }

  .left-items {
    margin-right: 10px;
  }

  .right-items {
  }

  .unit {
    margin-left: 5px;
  }
`;

export const Label = styled.label`
  display: inline-block;
  margin-bottom: 8px;

  .label__main {
    display: inline-flex;
    align-items: flex-start;

    & > * + * {
      margin-left: 4px;
    }
  }
`;

export const Wrapper = styled.div`
  min-width: 120px;
  position: relative;

  .textarea__placeholder {
    width: calc(100% - 32px);
    color: ${COLOR_SYSTEM.get("Gray")?.[300]};
    position: absolute;
    top: 11.5px;
    left: 17px;
  }

  .hint {
    display: block;
    margin-top: 8px;
  }
`;
